import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console for debugging
    console.error('ErrorBoundary caught:', error, errorInfo);

    // Optional: Send to analytics
    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: `ErrorBoundary: ${error.message}`,
        fatal: false,
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // Use custom fallback if provided
      if (this.props.fallback) {
        return this.props.fallback;
      }

      // Default fallback UI
      return (
        <div style={{
          padding: '40px 20px',
          textAlign: 'center',
          background: '#f8f9fa',
          borderRadius: '10px',
          margin: '20px 0'
        }}>
          <h3 style={{ color: '#666', marginBottom: '10px' }}>
            {this.props.title || 'Konten tidak dapat dimuat'}
          </h3>
          <p style={{ color: '#999', fontSize: '14px' }}>
            {this.props.message || 'Silakan refresh halaman atau lanjutkan scrolling'}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
